var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Filter, colour=NeutralDefault, htmlTag=img, assetKey=Content, state=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "filter_list",
    d: "M10.8295 18V16H14.8295V18H10.8295ZM6.82953 13V11H18.8295V13H6.82953ZM3.82953 8V6H21.8295V8H3.82953Z",
    fill: "#2F3846"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.ad37494f31ac1c6ead72d3309733a9af.svg";
export { ForwardRef as ReactComponent };